import {
  atomsLabelObjs,
  catcherMittBackofBeltBackStylePartsObjs,
  catcherMittBackofRegularBackStylePartsObjs,
  catcherMittBackPartsObjs,
  catcherMittCatchFaceObjs,
  catchFacePartsObjs,
  dispatchEuropeanSteerJa,
  dispatchNorthSteerJa,
  dispatchObjects,
  dispatchSteerJa,
  firstMittBackPartsNoBeltObjs,
  firstMittBackPartsObjs,
  gloveBeltBackPartsNoBeltObjs,
  gloveBeltBackPartsObjs,
  gloveCrownBackPartsObjs,
  gloveFirstBackPartsObjs,
  gloveUsBackPartsObjs,
  ALL_WELTINGS,
  WELTINGS_FOR_CATCHER_MITT,
  WELTINGS,
  infielderBackPartsForUBackObjs,
  listLiningsMaterialObjs,
  stitchColorObjs,
  LACES,
  BINDING_COLORS_JA
} from 'src/features/atoms/glove/japan/constants/colors'
import {
  backLaceObjs,
  backStyleForCatcherMittObjs,
  backStyleForPitcherObjs,
  backStyleObjs,
  dominantArmObjs,
  fingerGuardForFirstMittObjs,
  fingerGuardTypeAllObjects,
  fingerGuardTypeForOutfielderObjs,
  fingerGuardTypeObjs,
  loopOfRingFingerObjs,
  materialPackObjs,
  moldingJaObjs,
  printLeatherTypeObjs,
  sizeObjs
} from 'src/features/atoms/glove/japan/constants/bases'
import { colorObjs, positionObjs, shadowEdgeColorObjs, typeFaceObjs } from 'src/features/atoms/glove/japan/constants/embroidery'
import { initialStateCatcherMitt } from 'src/features/atoms/glove/japan/slice/catcher'
import { initialStateFirstMitt } from 'src/features/atoms/glove/japan/slice/first'
import { initialInfielderState } from 'src/features/atoms/glove/japan/slice/infielder'
import { initialOutfielderState } from 'src/features/atoms/glove/japan/slice/outfielder'
import { initialPitcherState } from 'src/features/atoms/glove/japan/slice/pitcher'
import { initialYouthState } from 'src/features/atoms/glove/japan/slice/youth'
import { tannerEnObjs, tannerObjs } from 'src/features/atoms/glove/us/constants/colors'
import { glovePriceTaxIncluded, mittPriceTaxIncluded } from 'src/features/atoms/glove/japan/constants/baseModel'
import { initialUsGloveState } from 'src/constants'

const positionJaOptions = [
  { label: '投手用', value: 'pitcher', attribute: 'pitcher' },
  { label: '捕手用', value: 'catcher', attribute: 'catcher' },
  { label: '一塁手', value: 'firstBaseman', attribute: 'first' },
  { label: '二塁手', value: 'secondBaseman', attribute: 'infielder' },
  { label: '三塁手', value: 'thirdBaseman', attribute: 'infielder' },
  { label: '遊撃手', value: 'shortStop', attribute: 'infielder' },
  { label: '左翼手', value: 'leftfielder', attribute: 'outfielder' },
  { label: '中堅手', value: 'centerfielder', attribute: 'outfielder' },
  { label: '右翼手', value: 'rightfielder', attribute: 'outfielder' }
]

const leagueOptions = [
  { label: 'プロ野球(NPB,独立L)', value: 'professional' },
  { label: '社会人野球', value: 'inCorporate' },
  { label: '大学野球', value: 'collegeLeague' },
  { label: '高校野球', value: 'highSchool' },
  { label: 'ボーイズリーグ', value: 'boysLeague' },
  { label: 'シニアリーグ', value: ' seniorLeague' },
  { label: 'ヤングリーグ', value: 'youngLeague' },
  { label: 'リトルリーグ', value: '' },
  { label: '草野球', value: 'hobby' }
]

export default {
  EXPLANATION_OF_PRICES: 'すべて税込価格です。',
  SIMULATABLE_BRANDS: 'シミュレーション可能なブランド',
  ORDER_SIMULATION: 'オーダーシミュレーション',
  IF_START_SIMULATION: `※シミュレーションを開始した場合、`,
  IF_START_SIMULATION_2: `利用規約に同意したものとみなします。`,
  START_BUTTON: 'シミュレーションを開始',
  CHECK_SIMULATION: 'シミュレーションを確認',
  TERMS_OF_USE: 'ご利用規約',
  TERMS_OF_USE_ITEM_1: '・本システムは、ATOMSグループのオーダーグラブのシュレミーションができることを目的にデザインされております。',
  TERMS_OF_USE_ITEM_2: '・一部デザインやカラーが実際の商品と異なる場合があります。',
  TERMS_OF_USE_ITEM_3: '・高校野球など、連盟ごとに使用制限がありますので各自ご確認下さい。',
  TERMS_OF_USE_ITEM_4: '・シミュレーション時に発行されるグラブIDの不正使用について、当社は一切の責任を負いません。',
  TERMS_OF_USE_ITEM_5: '・利用されたお客様のプライバシーを守るため、暗号化等の方法により、情報の保護に努めます。',
  TERMS_OF_USE_ITEM_6:
    '・本システムの利用は、お客様の責任において行われるものとします。当該システムおよび当該システムに非リンクされている他のウェブサイトから取得された各種情報の利用によって生じたあらゆる損害に関して、弊社は一切の責任を負いません。',
  TERMS_OF_USE_ITEM_7: '・当社システムは適宜見直しを行い、改訂することがあります。',
  TRANSLATE_CAUTION_DESCRIBE: '韓国語でシステムを引き続き利用する場合、Googleの自動翻訳機能をOFFにすることを推奨します。',
  LEGAL_NOTICE: '特定商法取引法に基づく表記',
  FOR_DETAIL: '詳しくはこちら↓',
  HOW_TO_OFF_GOOGLE_AUTO_TRANSLATE: 'Google Chromeの自動翻訳機能をOFFにする方法',
  DISABLE_MESSAGE_EVER: '今後このメッセージを表示しない',
  CLOSE: '閉じる',
  CHECKOUT: '購入に進む',
  PRODUCT_PAGE: '製品ページ',
  HARD_GLOVE_MITT: '硬式グローブ・ミット',
  HARD: '硬式',
  SOFT_BALL_GLOVE_MITT: '軟式グローブ・ミット',
  SOFT: '軟式',
  SHOES: 'スパイク・シューズ',
  BAT: 'バット',
  GLOVE: 'グローブ',
  MITT: 'ミット',
  COMMING_SOON: '(準備中)',
  BRAND_SELECTION_PAGE: 'ブランド選択ページ',
  POSITION_SELECTION_PAGE: 'ポジション選択ページ',
  SERIES_SELECTION_PAGE: 'シリーズ選択ページ',
  BRAND_SELECTION_PAGE_HEADLINE_US_MODEL: 'ATOMS (US Model)',
  BRAND_SELECTION_PAGE_HEADLINE_JAPAN_MODEL: 'ATOMS (Japan Model)',
  PITCHER: '投手用',
  CATCHER: '捕手用',
  INFIELDER: '内野手用',
  OUTFIELDER: '外野手用',
  FIRST_BASEMAN: '一塁手用',
  JAPAN_SERIES: '日本モデル',
  USA_SERIES: 'アメリカンモデル',
  KOREA_SERIES: '韓国モデル',
  PLEASE_SELECT_MODEL: '基本モデルを選択してください',
  PRODUCT_NUMBER: '型番：',
  START_SIMULATION: 'シミュレーションを開始',
  // ATOMS_投手用
  AKG_1: { description: '小ぶりな投手用で計量モデル', size: 29.8 }, // deprecated
  AKG_11: { description: '小ぶりの投手用。フィールディングにも優れる縦型モデル。', size: 29.0 }, // deprecated
  AKG_21: { description: 'ATOMS投手用初の縦型・縦綴じ採用グラブ', size: 29.8 }, // deprecated
  AGL_NE001: { description: 'オーソドックスな投手用。ポケットは深めで横ぶりモデル。', size: 30.0 },
  AGL_NE011: { description: '小ぶりな投手用で軽量モデル', size: 29.8 },
  AKG_PRO46: { description: '2023年使用 AKG-1同型のプロ選手モデル。', size: 30.0 },
  ATR_001: { description: '深めで縦型、しっかり掴める投手用。', size: 29.0 },
  US_PITCHER: { description: 'ポケットが深いタイプ。深めで縦型、しっかり掴める投手用。', size: 0 },
  // ATOMS_内野手用
  AGL_NE102: { description: '立ち上げ当初からある品番をより今のプレイヤーにあうように設計したグラブ。浅くも深くも使えるモデル', size: 28.3 },
  AGL_NE105: { description: 'ポケットが深く、安心して捕球できるオールラウンドモデル。', size: 29.0 },
  AGL_NE501: { description: '小さめの内野手用。手口も小さめででユースにも対応できるタイプ。', size: 27.8 },
  APL_NE021: { description: '型付けによって深くも浅くもできる内野手用の万能モデル。', size: 28.7 },
  APL_NE026: { description: '操作性を重視した内野手用モデル。やや小ぶりだが深みがあり、ウェブ下で捕るプレイヤー向け。', size: 28.3 },
  APL_NE066: { description: '捕球面が広く、掴み捕りや当て捕りがしやすい。グラブが開きやすく、中心捕球を好むプレイヤー向け。', size: 29.0 },
  APL_NE102: { description: '投手兼内野手用として使えるモデル。今のプレイヤーにあうように設計しエッジバスケットウェブを採用。', size: 28.3 },
  AKG_JS4_PLUS: { description: '変幻自在にどんな打球にも対応できるモデル。', size: 28.7 },
  AKG_JS5: { description: '土手は狭くしっかり掴んで捕るプレイヤー向け。', size: 28.3 },
  AKG_16: { description: 'ATOMS最軽量設計。指がシャープで操作性に優れ、ゴロがさばきやすいモデル。', size: 27.8 },
  AKG_4: { description: '変幻自在にどんな打球にも対応できるモデル。', size: 28.0 },
  AKG_5: { description: '現代野球スタイルの超スタンダード。選手のプレースタイルに型が馴染みやすいモデル。', size: 28.3 },
  AKG_6: { description: '内野手用で唯一「レギュラー巻き」を採用。手口のワイドさを軽減したモデル', size: 29.6 },
  APL_UR2: { description: '横振りにも使える深いグラブ。しっかりと掴む二遊間向けモデル。', size: 29.0 },
  APL_UR3: { description: '最も浅いグラブ。試合用でもトレーニング用でも対応できるモデル。', size: 27.5 },
  APL_UR4: { description: '深くなりにくい設計。捕球面を広く使いたいプレイヤー向け', size: 28.0 },
  APL_UR5: { description: 'ショート、サード向けの大きさでウェブ周りは強い打球にも負けない設計。', size: 28.3 },
  APL_UR10: { description: 'Uバックにエッジ付きウェブ採用モデル。', size: 28.0 },
  APL_UR026_PLUS: { description: '操作性を重視した内野手用。捕球から送球への流れがスムーズに行えるモデル', size: 28.3 },
  APL_UR004_PLUS: { description: 'Uバック採用の捕球面やや広めのモデル', size: 28.3 },
  APL_UR005_PLUS: { description: '捕球時、しっかりと掴むタイプ。強い打球にも負けない。ショート・サード向き', size: 28.3 },
  APL_UR006_PLUS: { description: 'ATR-006+後継モデル。プロ野球選手も使用する型でやや大きめのBOX型。', size: 29.5 },
  APL_UR015_PLUS: { description: '深めでしっかり包み込むタイプの型。', size: 29.0 },
  APL_UR066_PLUS: { description: 'NEWモデル。AKG-6型を少し小ぶりにし、 操作性を高くしたモデル。', size: 29.0 },
  AGL_105: { description: '投手兼オールラウンドタイプ。', size: 29.0 },
  AGL_501: { description: '小さめの内野手用。手口も小さめ。ユースにも対応できるタイプ。', size: 27.8 },
  AGL_503: { description: '深く広く使えるタイプの内野手用モデル', size: 28.6 },
  AGL_601: { description: '内野手用の中では大きめなタイプのボックス型です。', size: 29.6 },
  AGL_603: { description: 'ATOMSでは少ない横ぶりの内野手用モデル。小さめでポケットを 作りやすく、逆シングルにも対応しやすいタイプ。', size: 29.3 },
  ATR_006: { description: 'ポケットは横に広く、当て捕りも掴みもできるタイプ。', size: 29.5 },
  US_INFIELDER: { description: '深めの設計。ボールを掴む感覚を重視するプレイヤー向けモデル', size: 0 },
  // ATOMS_外野手用
  AGL_NE801: { description: '小ぶりな外野手用グラブ。軽量でポケット深めのモデル', size: 30.5 },
  AGL_NE008: { description: 'ポケットが深くしっかり捕れるモデル', size: 33.0 },
  APL_NE702: { description: '縦長で深めの外野手用。指先まで操作しやすいモデル。', size: 32.0 },
  AKG_7: { description: '指がシャープな縦型。ポケットが狭く、ボールの遊びが少ないため、次の動作へのブレが少ないモデル。', size: 31.5 },
  AKG_JS7: { description: 'シャープな縦型でポケットは深めのモデル。', size: 32.0 },
  AKG_GT07: { description: 'NEWモデル。ポケットは深くしっかり捕れるタイプ。', size: 33.0 },
  AKG_17: { description: 'ポケットは深めで広く、しっかり包み込むタイプのモデル。', size: 32.8 },
  AKG_27: { description: '外野手用としては小さめ。ポケット深めの設計で ソフトボールに対応できるタイプ。', size: 31.5 },
  ATR_007: { description: 'ポケットは深く、強い打球にも負けない外野手用。', size: 32.5 },
  AGL_801: { description: '小ぶりな外野手用。軽量かつポケットが深いタイプ。', size: 30.5 },
  APL_UR6: { description: '小さめながらしっかり掴めるモデル。', size: 31.5 },
  APL_UR007_PLUS: { description: 'ポケットは深く、強い打球にも負けない外野手用。', size: 32.5 },
  APL_UR008_PLUS: { description: 'NEWモデルAKG-GT07同型のERMリストタイプ。', size: 33.0 },
  US_OUTFIELDER: { description: 'ポケットは深く、強い打球にも負けない外野手用。', size: 0 },
  // ATOMS_捕手用
  AGL_NE002: { description: 'レギュラーバック採用のキャッチャーミット。', size: 32.5 },
  AKG_12: { description: '小ぶりで操作性も高く使いやすいモデル。', size: 32.5 },
  AKG_JS2: { description: '浅めでボールの握り替えがスムーズに出来るモデル。ウェブは硬い設計。', size: 31.5 },
  APL_UR002_PLUS: { description: 'レギュラーバックとERMリストにより操作性抜群', size: 31.5 },
  AKG_GT22: { description: 'NEWモデル。レギュラーバック採用ミット。', size: 32.5 },
  // ATOMS_一塁手用
  AGL_NE003: { description: 'ポケットが広くしっかりと捕球できるファーストミット。', size: 32.5 },
  AKG_13: { description: '操作性も高い小さめのモデル', size: 32.5 },
  APL_UR003_PLUS: { description: '小型の一塁手用グラブのような操作性', size: 32.5 },
  AKG_GT33: { description: 'NEWモデル。しっかり捕球できる新型ウェブ採用', size: 32.5 },
  DRAWING_CAUTION: '※グラブ・ミットの描画、刺繍の位置・書体はイメージであり、実際とは異なる場合があります。',
  DRAWING_SHOES_CAUTION: '※スパイク・シューズの描画、刺繍の位置・書体はイメージであり、実際とは異なる場合があります。',
  STAFF_ONLY: '※ATOMSスタッフ専用シミュレーションです。',
  CATCH_SURFACE: '捕球面',
  BACK_SURFACE: '背面',
  SELECTED_BASE_MODEL: '選択中の基本モデル',
  TO_TOP: 'トップへ',
  RESET: 'リセット',
  SEARCH: '検索',
  SEARCHING: '検索中...',
  CONFIRM: '確認',
  CONFIRM_TO_TOP: '本当にトップページに移動しますか？',
  CONFIRM_RESET: `本当にリセットしますか？\n全ての設定がリセットされます`,
  CONFIRM_SEND_EMAIL: `データを保存し、メールアドレス先に保存IDを送付します。`,
  CONFIRM_START_SIMULATION: ` を元にシミュレーションを開始します。`,
  PARTS_SETTING: 'パーツ設定',
  COLOR_SETTING: 'カラー設定',
  EMBROIDERY_SETTING: '刺繍設定',
  BASE_MODEL: '基本モデル',
  KINDS: '種別',
  TANNER: 'タンナー',
  ATOMS_LEATHER: 'レザー',
  ATOMS_LEATHER_RESET_DESCRIPTION: '変更するにはシミュレーションをリセットしてください。',
  DOMINANT_ARM: '利き腕',
  BACK_STYLE: 'バックスタイル',
  MATERIAL_PACK: '芯とじスタイル',
  FINGER_SIZE: '指の長さ',
  BACK_LACE: '背面紐通し',
  WEB: 'ウェブ',
  WEB2: 'ウェブ2',
  FINGER_GUARD: '指カバー/指あて',
  MOLDING_ORDER: 'オリジナル型付け',
  FINGER_TIP_OUT: '指だし',
  STAND: '背面台',
  TARGET: 'ターゲット',
  PARTS: 'パーツ',
  COLOR: ' カラー',
  LACE: 'レース',
  STITCH: 'ステッチ',
  HAMIDASHI: 'ハミダシ',
  EDGE: 'ヘリ革',
  THUMB_HOOK: '親指掛け紐',
  LITTLE_HOOK: '小指掛け紐',
  LININGS: '平裏',
  MOUTON: 'ムートン',
  PRINT_LEATHER_TYPE: 'プリント革',
  LABEL: 'ラベル',
  THUMB: '親指',
  THUMB1: '親指1',
  THUMB_INDEX_MIDDLE5: '親指・人差指・中指5',
  THUMB2: '親指2',
  THUMB_ROOT: '親指根本',
  INDEX: '人差指',
  INDEX3: '人差指3',
  INDEX4: '人差指4',
  MIDDLE: '中指',
  MIDDLE5: '中指5',
  MIDDLE6: '中指6',
  RING: '薬指',
  RING7: '薬指7',
  RING8: '薬指8',
  LITTLE: '小指',
  LITTLE9: '小指9',
  LITTLE10: '小指10',
  THUMB2_INDEX3: '親指2・人差指3',
  THUMB2_INDEX3_MIDDLE4: '親指2・人差指3・中指4',
  THUMB2_INDEX_MIDDLE5: '親指2・人差指3,4・中指5',
  THUMB2_INDEX_MIDDLE_RING7: '親指2・人差指3,4・中指5,6・薬指7',
  INDEX4_MIDDLE5: '人差指4・中指5',
  MIDDLE6_RING: '中指6・薬指',
  MIDDLE5_RING6: '中指5・薬指6',
  MIDDLE6_RING7: '中指6・薬指7',
  MIDDLE6_RING_PINKY: '中指6・薬指・小指',
  RING7_LITTLE8: '薬指7・小指8',
  RING8_LITTLE9: '薬指8・小指9',
  BELT: 'ベルト',
  FIRST_BACK_BELT: 'ベルト',
  BAND: 'バンド',
  UNDER_WEB: 'ウェブ下',
  BOOMERANG: 'ブーメラン',
  LOOP_OF_RING: '薬指リング',
  POSITION: '位置',
  TYPE_FACE: '書体',
  MAIN_COLOR: '刺繍カラー',
  POINT_COLOR: 'ポイントカラー',
  SHADOW_COLOR: '影カラー',
  EDGE_COLOR: 'フチカラー',
  EMBROIDERY_CONTENTS: '刺繍内容',
  ENTER_EMBROIDERY_CONTENTS: '刺繍内容を入力してください',
  EMBROIDERY_CONTENT_DIALOG_TITLE: '刺繍{n} - {summary}',
  EMBROIDERY_CONTENT_INPUT_COMPLETE: '入力完了',
  MAX_NUMBER_OF_CHAR: '最大文字数',
  CHARACTERS: '文字',
  BASE_ITEMS: '基本項目',
  COLOR_ITEMS: 'カラー項目',
  PRICE_ITEMS: '価格項目',
  EMBROIDERY_ITEMS: '刺繍項目',
  NO_EMBROIDERY: '刺繍なし',
  BASE_PRICE: '基本金額：',
  EMBROIDERY_PRICE: '刺繍金額：',
  OPTION_PRICE: 'オプション金額：',
  SHIPPING_PRICE: '送料：',
  TOTAL_PRICE: '合計金額：',
  MONEY_UNIT: '円',
  SIZE_UNIT: ' cm',
  COPY: 'コピー',
  COPIED: 'コピー済',
  SAVED_ID: '保存ID',
  SAVE_CAUTION: 'シミュレーション内容は、こちらの画面をスクリーンショット等で、予め保存いただきますようお願いいたします。',
  CUSTOMER_INFORMATION: 'お客様情報',
  CUSTOMER_NAME: 'お名前',
  CUSTOMER_INFORMATION_CAUTION: '項目を全て選択後、お客様情報をご入力いただけます。',
  DUPLICATE_EMBROIDERY_POSITION_CAUTION: '刺繍位置が重複しています。重複が無いよう再度ご確認ください。',
  LEAGUE: 'リーグ',
  FIELD_POSITION: '守備位置',
  EMAIL_ADDRESS: 'メールアドレス',
  EMAIL_ADDRESS_RETYPE: 'メールアドレス(再入力)',
  SAVE_BUTTON: '保存',
  NOW_SAVING: '保存中...',
  RETAIL_LOGIN_PAGE_HEADER: '小売店用ログイン画面',
  RETAIL_LOGIN_PAGE_EXPLAIN: '小売店員の方はログインの上、お客様のシミュレーション結果をIDで検索をしてください',
  LOGIN: 'ログイン',
  NOW_LOGING: 'ログイン中...',
  NOW_LOADING: '読み込み中...',
  BACK_TO_TOP: 'トップへ戻る',
  PASSWORD: 'パスワード',
  RESET_PASSWORD: 'パスワードをリセット',
  PAGE_OF_RESET_PASSWORD: '小売店用パスワードリセット画面',
  DESCRIPTION_OF_HOW_TO_RESET_PASSWORD: '該当のメールアドレスを入力し、送信ボタンを押してください。',
  SEND_RESET_EMAIL: 'リセットメールを送信',
  TO_RETAIL_LOGIN_PAGE: '小売店ログイン画面へ',
  CAUTION_SENT_RESET_EMAIL: '送信しました。受信されない場合、迷惑メール扱いになっていないかもご確認ください。',
  SELECT_BRAND: 'ブランドを選択',
  SELECT_PRODUCT: '製品を選択',
  SIMULATION_ID: 'シミュレーションID',
  ENTER_ID: 'IDを入力',
  LOGOUT: 'ログアウト',
  RETAIL_CAUTION_1: 'このブランドは取扱対象外なため、検索できません。',
  RETAIL_CAUTION_2: '検索されたシミュレーションIDは、選択されたブランドでは見つかりませんでした。正しいブランドを選択してください。',
  NAME: 'お名前：',
  TEL: 'お電話：',
  REMARK: '備考欄：',
  CUSTOMER_FORM_CAUTION_1: '※料金は予告なく変更される可能性があります。',
  CUSTOMER_FORM_CAUTION_2: '※備考欄に記載いただいたご要望にお応えできない場合がございます。',
  CUSTOMER_FORM_CAUTION_3: '※特別なご要望等は、お手数ですが代理店担当者にもお問い合わせください。',
  TANNER_OBJECTS: tannerObjs,
  TANNER_OBJECTS_US: tannerEnObjs,
  DOMINANT_ARM_OBJECTS: dominantArmObjs,
  BACK_STYLE_OBJECTS: backStyleObjs,
  BACK_STYLE_FOR_PITCHER_OBJECTS: backStyleForPitcherObjs,
  BACK_STYLE_FOR_CATCHER_OBJECTS: backStyleForCatcherMittObjs,
  FINGER_GUARD_TYPE_DESCRIPTION: 'バックスタイルを先に選択してください。',
  MATERIAL_PACK_OBJECTS: materialPackObjs,
  SIZE_OBJECTS: sizeObjs,
  MOLDING_OBJECTS: moldingJaObjs,
  LOOP_OF_RING_FINGER_OBJECTS: loopOfRingFingerObjs,
  LOOP_OF_RING_FINGER_DESCRIPTION: 'オプション：3,300円, ※カラーは裏平と同色になります。',
  BACK_LACE_OBJECTS: backLaceObjs,
  FINGER_GUARD_TYPE_FOR_OUTFIELDER_OBJECTS: fingerGuardTypeForOutfielderObjs,
  FINGER_GUARD_TYPES_FOR_FIRST_BASEMAN: fingerGuardForFirstMittObjs,
  FINGER_GUARD_TYPE_OBJECTS: fingerGuardTypeObjs,
  FINGER_GUARD_TYPE_ALL_OBJECTS: fingerGuardTypeAllObjects,
  CAUTION_TANNER: '※一部パーツのカラーに適用されます',
  CAUTION_DOMINANT_ARM: '',
  CAUTION_SIZE: 'サイズ変更はオプション料金が発生します。',
  CAUTION_MOLDING_ORDER: 'オプション: 5,500円',
  // CAUTION_MATERIAL_PACK: '「捕球面」の土手の形状が変わります。',
  CAUTION_LACE: '中白系カラーは断面が白色です。シュミレーションには反映されません。',
  CAUTION_BACK_STYLE: '変更するためには、指カバーを一度"無し"にしてください。',
  PRINT_LEATHER_TYPE_DESCRIPTION: '選択すると本体背面が全てプリント革になります。',
  LACE_COLOR_OBJECTS: LACES,
  EDGE_COLOR_OBJECTS: BINDING_COLORS_JA,
  STITCH_COLOR_OBJECTS: stitchColorObjs,
  HAMIDASHI_COLOR_OBJECTS: WELTINGS,
  HAMIDASHI_COLOR_ALL_OBJECTS: ALL_WELTINGS,
  HAMIDASHI_COLOR_FOR_CATCHER_OBJECTS: WELTINGS_FOR_CATCHER_MITT,
  MOUTON_COLOR_OBJECTS: listLiningsMaterialObjs,
  PRINT_LEATHER_TYPE_OBJECTS: printLeatherTypeObjs,
  LABEL_COLOR_OBJECTS: atomsLabelObjs,
  SELECT_BACK_STYLE_DESCRIBE: 'バックスタイルを先に選択してください。',
  // dispatchここから
  DISPATCH_COLOR_OBJECTS: dispatchObjects,
  DISPATCH_EUROPEAN_LEATHER_COLOR_OBJECTS: dispatchEuropeanSteerJa,
  DISPATCH_NORTH_LEATHER_COLOR_OBJECTS: dispatchNorthSteerJa,
  DISPATCH_STEER_LEATHER_COLOR_OBJECTS: dispatchSteerJa,
  DISPATCH_US_LEATHER_COLOR_OBJECTS: dispatchObjects,
  // dispatchここまで
  CATCH_FACE_OBJECTS: catchFacePartsObjs,
  CATCH_FACE_FOR_CATCHER_OBJECTS: catcherMittCatchFaceObjs,
  // 背面パーツここから
  FIRST_BACK_OBJECTS: gloveFirstBackPartsObjs,
  CROWN_BACK_OBJECTS: gloveCrownBackPartsObjs,
  BELT_BACK_OBJECTS: gloveBeltBackPartsObjs,
  US_MODEL_BACK_OBJECTS: gloveUsBackPartsObjs,
  UBACK_OBJECTS: infielderBackPartsForUBackObjs,
  NO_BELT_BACK_OBJECTS: gloveBeltBackPartsNoBeltObjs,
  C_MITT_REGULAR_BACK_OBJECTS: catcherMittBackofRegularBackStylePartsObjs,
  C_MITT_BELT_BACK_OBJECTS: catcherMittBackofBeltBackStylePartsObjs,
  C_MITT_BACK_OBJECTS: catcherMittBackPartsObjs,
  F_MITT_NO_BELT_BACK_OBJECTS: firstMittBackPartsNoBeltObjs,
  F_MITT_BACK_OBJECTS: firstMittBackPartsObjs,
  EMBROIDERY_POSITION_OBJECTS: positionObjs,
  EMBROIDERY_TYPEFACE_OBJECTS: typeFaceObjs,
  EMBROIDERY_COLOR_OBJECTS: colorObjs,
  EMBROIDERY_SHADOW_EDGE_COLOR_OBJECTS: shadowEdgeColorObjs,
  CAUTION_EMBROIDERY_POSITION:
    '刺繍位置を変更するには、刺繍内容をリセットしてください。実際の位置と若干異なる場合があります。カタログも併せてご確認ください。',
  CAUTION_EMBROIDERY_TYPEFACE: '書体は実際のものと若干異なる場合があります。予めご了承ください。',
  CAUTION_EMBROIDERY_CONTENTS: '"刺繍位置" を選択してください。',
  CAUTION_EMBROIDERY_SHADOW_EDGE_COLOR: '"刺繍カラー" を選択してください。',
  DESCRIBE_EMBROIDERY_PLUS_BUTTON: '2か所刺繍ご希望の場合には「+」をクリックの上、刺繍2を表示し入力して下さい。',
  DESCRIBE_EMBROIDERY_MINUS_BUTTON: '1か所削除したい場合には、「-」をクリックしてください。',
  SELECT_CARD_WITH_CONFIRM_OPEN_LABEL: '{{summary}}を選択',
  SELECT_CARD_WITH_CONFIRM_DIALOG_TITLE: '{{summary}}を選択',
  SELECT_CARD_WITH_CONFIRM_SELECTED_BADGE: '（選択中）',
  SELECT_CARD_WITH_CONFIRM_TAX_INCLUDED: '税込 {{price}}{{unit}}',
  SELECT_CARD_WITH_CONFIRM_AVAILABLE_COLORS_CATCH_FACE: '選択可能なレザーカラー（捕球面）',
  SELECT_CARD_WITH_CONFIRM_CANCEL: 'キャンセル',
  SELECT_CARD_WITH_CONFIRM_SELECT: '選択',
  SELECT_CARD_WITH_CONFIRM_SELECT_OPTION: '「{{label}}」を選択',
  SELECT_CARD_WITH_CONFIRM_CAUTION_ONCE_SELECTED: '※一度選択すると変更できません。',
  NO_SELECTION: '選択不可',
  INITIAL_STATE_C_MITT: initialStateCatcherMitt,
  INITIAL_STATE_F_MITT: initialStateFirstMitt,
  INITIAL_STATE_INFIELDER: initialInfielderState,
  INITIAL_STATE_OUTFIELDER: initialOutfielderState,
  INITIAL_STATE_PITCHER: initialPitcherState,
  INITIAL_STATE_US_GLOVE: initialUsGloveState,
  INITIAL_STATE_YOUTH: initialYouthState,
  TO_OTHER_LANGUAGES_PAGE: 'To English Page →',
  SENDING_MAIL: '送信中...',
  SEND_MAIL_SUCCESS_FULL: '送信完了',
  LEAGUE_OPTIONS: leagueOptions,
  POSITION_OPTIONS: positionJaOptions,
  BASE_PRICE_GLOVE: glovePriceTaxIncluded,
  BASE_PRICE_MITT: mittPriceTaxIncluded,
  MAIN_COLOR_PRICE: 2420, // 税込
  SHADOW_COLOR_PRICE: 2970, // 税込
  EDGE_COLOR_PRICE: 4620, // 税込
  AHN_JAE_SEOK_MODEL: { description: '', size: 0, productNumber: 'アン・ジェソク モデル' },
  SHIN_JUNG_WOO_MODEL: { description: '', size: 0, productNumber: 'シン・ジュンウ モデル' },
  PARK_GE_BUM_MODEL: { description: '', size: 0, productNumber: 'パク・ゲボム モデル' },
  HAFN_DONG_HEE_MODEL: { description: '', size: 0, productNumber: 'ハン・ドンヒ モデル' },
  LANGUAGE: '言語',
  WEB2_PARTS_OBJECT: { value: 'web2', label: 'ウェブ2', order: 3 },
  EMBROIDERY_CONTENT_EMOJI_CAUTION: '絵文字・記号は⭐︎,❤️,♯,🎵のみ刺繍可能です。',
  PAYMENT_MANAGEMENT: '決済管理画面へ',
  ORDER_SPECIFICATION: 'オーダー仕様書',
  ORDER_DATE: '発行日',
  ORDERING_PARTY: '発注元',
  NO_EMBROIDERY_SELECTED: '通常刺繍なし',
  // Legal page
  LEGAL_TITLE: '特定商取引法に基づく表記',
  LEGAL_DESCRIPTION: '特定商取引法に基づき、以下の通り表記いたします。',
  LEGAL_ITEM: '項目',
  LEGAL_CONTENT: '内容',
  LEGAL_COMPANY_NAME: '販売業者名',
  LEGAL_COMPANY_NAME_VALUE: '株式会社ATOMS（ATOMS, inc）',
  LEGAL_REPRESENTATIVE: '責任者氏名',
  LEGAL_REPRESENTATIVE_VALUE: '代表取締役社長 石川 佳和',
  LEGAL_ADDRESS: '所在地',
  LEGAL_ADDRESS_VALUE: '〒633-0067 奈良県桜井市大福156-4',
  LEGAL_PHONE: '電話番号',
  LEGAL_PHONE_VALUE: '0744-46-5181',
  LEGAL_EMAIL: 'メールアドレス',
  LEGAL_EMAIL_VALUE: 'atoms.sns@gmail.com',
  LEGAL_CONTACT: 'お問い合わせ',
  LEGAL_CONTACT_VALUE: 'https://atoms-inc.com/contact/',
  LEGAL_PAYMENT_METHOD: 'お支払い方法',
  LEGAL_PAYMENT_METHOD_VALUE: 'クレジットカード, Apple Pay',
  LEGAL_OTHER_FEES: '商品代金以外の必要料金',
  LEGAL_OTHER_FEES_VALUE: '送料：全国一律1,100円（税込)',
  LEGAL_TAX: '消費税',
  LEGAL_TAX_VALUE: '全ての商品の表示価格は、消費税込みの価格となります。',
  LEGAL_RETURN_POLICY: '返品・キャンセルについて',
  LEGAL_RETURN_POLICY_VALUE:
    '受注生産のため、ご注文後のキャンセル・返品はお受けできません。\n\n商品はご注文後に製造いたします。お客様のご都合による返品・交換はいたしかねます。',
  LEGAL_DELIVERY_TIME: '引き渡し時期',
  LEGAL_DELIVERY_TIME_VALUE: '通常、発注完了後から3ヶ月でのご納品となります。\n※繁忙期にはご納品にお時間を頂戴する場合がございます。',
  // YSRの台湾語対応ここから
  SERIES: 'シリーズ',
  FINGER_PAD: '指あて',
  LEATHER_INTEGRATED_INDEX: '革一体形状(人差指)',
  LEATHER_INTEGRATED_MIDDLE: '革一体形状(中指)',
  LEATHER_INTEGRATED_RING: '革一体形状(薬指)',
  ORIGINAL_EMBROIDERY: 'オリジナル刺繍',
  DIRECT_LOGO_EMBROIDERY_1: 'ダイレクトロゴ刺繍1',
  DIRECT_LOGO_EMBROIDERY_1_MAIN_COLOR: 'ダイレクトロゴ刺繍1 本体カラー',
  DIRECT_LOGO_EMBROIDERY_1_EDGE_COLOR: 'ダイレクトロゴ刺繍1 フチカラー',
  DIRECT_LOGO_EMBROIDERY_2: 'ダイレクトロゴ刺繍2',
  DIRECT_LOGO_EMBROIDERY_2_COLOR: 'ダイレクトロゴ刺繍2 カラー',
  BREAD_CRUMB_TRAIL_YSR: '硬式グラブ / Yell story / 内野手用'
}
